import { IMilestoneCategory } from '../../../api/getMilestone';
import {
    NotesIcon,
    completedEarlyIcon,
    completedWithDelayIcon,
    dangerIcon,
    dueIcon,
    resetIcon,
    tickIcon2,
    trashIcon,
} from '../Icons';
import { IMilestoneStatus } from '../types/milestones';

export const otherOptions: {
    title: string;
    optionTitle: string;
    icon: JSX.Element;
    status?: IMilestoneStatus;
}[] = [
    {
        title: 'Under observation',
        optionTitle: 'Mark under observation',
        icon: dueIcon('w-14 h-14'),
        status: 'under_observation',
    },
    {
        title: 'Delayed',
        optionTitle: 'Mark delayed',
        icon: dangerIcon('w-14 h-14'),
        status: 'delayed',
    },
];

export const acheivedOptions: {
    title: string;
    optionTitle: string;
    icon: JSX.Element;
    status?: IMilestoneStatus;
}[] = [
    {
        title: 'Achieved as per age',
        optionTitle: 'Achieved as per age',
        icon: (
            <span className="border m-2 border-darwin-green-primary flex items-center justify-center rounded-full">
                {tickIcon2('fill-darwin-green-primary font-700 w-12 h-12')}
            </span>
        ),
        status: 'achieved',
    },
    {
        title: 'Achieved after delay',
        optionTitle: 'Achieved after delay',
        icon: completedWithDelayIcon('w-18 h-18'),
        status: 'achieved_delay',
    },
    {
        title: 'Achieved early',
        optionTitle: 'Achieved early',
        icon: completedEarlyIcon('w-18 h-18 m-0'),
        status: 'achieved_early',
    },
    {
        title: 'Achieved',
        optionTitle: 'Achieved',
        icon: (
            <span className="border m-2 border-darwin-green-primary flex items-center justify-center rounded-full">
                {tickIcon2('fill-darwin-green-primary font-700 w-12 h-12')}
            </span>
        ),
        status: 'achieved_unknown',
    },
];

export const achievedStatuses = acheivedOptions.map((opt) => opt.status);

export const milestoneCategories: IMilestoneCategory[] = [
    'ek-7084767782',
    'ek-1025408070',
    'ek-9994397806',
    'ek-9916604356',
    // 'audio',
    // 'visual',
    // 'other',
];

export const milestoneIdNameMapping = {
    'ek-7084767782': 'gross_motor',
    'ek-1025408070': 'fine_motor',
    'ek-9916604356': 'language',
    'ek-9994397806': 'social',
};

export const milestoneStatus: IMilestoneStatus[] = [
    'achieved',
    'achieved_early',
    'achieved_delay',
    'under_observation',
    'delayed',
];

export const mileStonesoptions: {
    title?: string;
    optionTitle: string;
    icon: JSX.Element;
    status?: string;
}[] = [
    ...otherOptions,
    {
        optionTitle: 'Add notes',
        icon: NotesIcon('fill-darwin-neutral-1000'),
        status: 'add_notes',
    },
];

export const milestoneDeleteOptions = [
    {
        optionTitle: 'Reset Milestone',
        icon: resetIcon('w-12 h-12 fill-darwin-neutral-1000'),
        status: 'reset',
    },
    {
        optionTitle: 'Delete',
        icon: trashIcon('w-12 h-14'),
        status: 'delete',
    },
];

export const allMilestoneOptions = [...acheivedOptions, ...otherOptions];

export const milestoneCardConfig: Record<IMilestoneStatus, { bg: string; border: string }> = {
    achieved: {
        bg: 'bg-darwin-green-bg-dark',
        border: 'border-darwin-green-primary',
    },
    delayed: {
        bg: 'bg-background-light-red',
        border: 'border-red-primary',
    },
    achieved_delay: {
        bg: 'bg-darwin-green-bg-dark',
        border: 'border-darwin-green-primary',
    },
    achieved_early: {
        bg: 'bg-darwin-green-bg-dark',
        border: 'border-darwin-green-primary',
    },
    achieved_unknown: {
        bg: 'bg-darwin-green-bg-dark',
        border: 'border-darwin-green-primary',
    },
    under_observation: {
        bg: 'bg-darwin-accent-bright-yellow-200',
        border: 'border-darwin-accent-bright-yellow-800',
    },
};

export const mileStoneCategoryName = {
    'ek-7084767782': 'Gross Motor',
    'ek-1025408070': 'Fine Motor',
    'ek-9916604356': 'Language',
    'ek-9994397806': 'Social',
    // other: 'Other',
    // visual: 'Visual',
    // audio: 'Audio',
};
